/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Reviews API
 * API for managing review configurations, questions, and answers
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get all review configurations
 */
export const getReviewConfigsQueryLimitMax = 100;

export const getReviewConfigsQueryOffsetMin = 0;

export const GetReviewConfigsQueryParams = zod
    .object({
        is_active: zod.number().optional().describe("Filter by active status"),
        search: zod.string().optional().describe("Search by config name or description"),
        limit: zod.number().min(1).max(getReviewConfigsQueryLimitMax).optional().describe("Number of items to return"),
        offset: zod.number().min(getReviewConfigsQueryOffsetMin).optional().describe("Number of items to skip"),
    })
    .strict();

export const GetReviewConfigsHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getReviewConfigs200ResponseDataItemReviewConfigNameMax = 70;

export const GetReviewConfigs200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    review_config_id: zod.number().optional(),
                    review_config_name: zod
                        .string()
                        .max(getReviewConfigs200ResponseDataItemReviewConfigNameMax)
                        .optional(),
                    general_description: zod.string().optional(),
                    is_active: zod.number().optional(),
                    created_at: zod.string().datetime({ offset: true }).optional(),
                    updated_at: zod.string().datetime({ offset: true }).optional(),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

export const GetReviewConfigs400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewConfigs500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create new review configuration
 */
export const CreateReviewConfigHeader = zod
    .object({
        "Content-Type": zod.enum(["application/json"]).describe("Content type of the request body"),
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const createReviewConfigBodyReviewConfigNameMax = 70;

export const createReviewConfigBodyIsActiveDefault = 1;

export const CreateReviewConfigBody = zod
    .object({
        review_config_name: zod.string().max(createReviewConfigBodyReviewConfigNameMax),
        general_description: zod.string(),
        is_active: zod.number().default(createReviewConfigBodyIsActiveDefault),
    })
    .strict();

export const createReviewConfig201ResponseDataItemReviewConfigNameMax = 70;

export const CreateReviewConfig201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_config_id: zod.number().optional(),
                        review_config_name: zod
                            .string()
                            .max(createReviewConfig201ResponseDataItemReviewConfigNameMax)
                            .optional(),
                        general_description: zod.string().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateReviewConfig400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const CreateReviewConfig500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get all review configurations with nested questions
 */
export const GetReviewConfigsWithQuestionsQueryParams = zod
    .object({
        is_active: zod.number().optional().describe("Filter by active status"),
        search: zod.string().optional().describe("Search by config name or description"),
    })
    .strict();

export const GetReviewConfigsWithQuestionsHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getReviewConfigsWithQuestions200ResponseDataItemOneReviewConfigNameMax = 70;

export const getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextThMax = 200;

export const getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextEnMax = 200;

export const getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextJaMax = 200;

export const GetReviewConfigsWithQuestions200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    review_config_id: zod.number().optional(),
                    review_config_name: zod
                        .string()
                        .max(getReviewConfigsWithQuestions200ResponseDataItemOneReviewConfigNameMax)
                        .optional(),
                    general_description: zod.string().optional(),
                    is_active: zod.number().optional(),
                    created_at: zod.string().datetime({ offset: true }).optional(),
                    updated_at: zod.string().datetime({ offset: true }).optional(),
                    questions: zod
                        .array(
                            zod
                                .object({
                                    review_question_id: zod.number().optional(),
                                    review_config_id: zod.number().optional(),
                                    question_text_th: zod
                                        .string()
                                        .max(
                                            getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextThMax,
                                        )
                                        .optional(),
                                    question_text_en: zod
                                        .string()
                                        .max(
                                            getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextEnMax,
                                        )
                                        .optional(),
                                    question_text_ja: zod
                                        .string()
                                        .max(
                                            getReviewConfigsWithQuestions200ResponseDataItemTwoQuestionsItemQuestionTextJaMax,
                                        )
                                        .optional(),
                                    data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
                                    options: zod.array(zod.string()).optional(),
                                    option_th: zod.array(zod.string()).optional(),
                                    option_en: zod.array(zod.string()).optional(),
                                    option_ja: zod.array(zod.string()).optional(),
                                    is_required: zod.number().optional(),
                                    is_active: zod.number().optional(),
                                    created_at: zod.string().datetime({ offset: true }).optional(),
                                    updated_at: zod.string().datetime({ offset: true }).optional(),
                                })
                                .strict(),
                        )
                        .optional(),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                current_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

export const GetReviewConfigsWithQuestions400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewConfigsWithQuestions500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get specific review configuration
 */

export const GetReviewConfigParams = zod
    .object({
        review_config_id: zod.number().min(1),
    })
    .strict();

export const GetReviewConfigHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getReviewConfig200ResponseDataItemReviewConfigNameMax = 70;

export const GetReviewConfig200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_config_id: zod.number().optional(),
                        review_config_name: zod
                            .string()
                            .max(getReviewConfig200ResponseDataItemReviewConfigNameMax)
                            .optional(),
                        general_description: zod.string().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetReviewConfig404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewConfig500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Update review configuration
 */

export const UpdateReviewConfigParams = zod
    .object({
        review_config_id: zod.number().min(1),
    })
    .strict();

export const UpdateReviewConfigHeader = zod
    .object({
        "Content-Type": zod.enum(["application/json"]).describe("Content type of the request body"),
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const updateReviewConfigBodyReviewConfigNameMax = 70;

export const UpdateReviewConfigBody = zod
    .object({
        review_config_name: zod.string().max(updateReviewConfigBodyReviewConfigNameMax).optional(),
        general_description: zod.string().optional(),
        is_active: zod.number().optional(),
    })
    .strict();

export const updateReviewConfig200ResponseDataItemReviewConfigNameMax = 70;

export const UpdateReviewConfig200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_config_id: zod.number().optional(),
                        review_config_name: zod
                            .string()
                            .max(updateReviewConfig200ResponseDataItemReviewConfigNameMax)
                            .optional(),
                        general_description: zod.string().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdateReviewConfig400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateReviewConfig404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateReviewConfig500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Delete review configuration
 */

export const DeleteReviewConfigParams = zod
    .object({
        review_config_id: zod.number().min(1),
    })
    .strict();

export const DeleteReviewConfigHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const DeleteReviewConfig404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const DeleteReviewConfig500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get all questions for a review configuration
 */

export const GetReviewQuestionsParams = zod
    .object({
        review_config_id: zod.number().min(1),
    })
    .strict();

export const getReviewQuestionsQueryLimitMax = 100;

export const getReviewQuestionsQueryOffsetMin = 0;

export const GetReviewQuestionsQueryParams = zod
    .object({
        is_active: zod.number().optional().describe("Filter by active status"),
        data_type: zod
            .enum(["rating", "text", "single_select", "multi_select"])
            .optional()
            .describe("Filter by question data type"),
        limit: zod
            .number()
            .min(1)
            .max(getReviewQuestionsQueryLimitMax)
            .optional()
            .describe("Number of items to return"),
        offset: zod.number().min(getReviewQuestionsQueryOffsetMin).optional().describe("Number of items to skip"),
    })
    .strict();

export const GetReviewQuestionsHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getReviewQuestions200ResponseDataItemQuestionTextThMax = 200;

export const getReviewQuestions200ResponseDataItemQuestionTextEnMax = 200;

export const getReviewQuestions200ResponseDataItemQuestionTextJaMax = 200;

export const GetReviewQuestions200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    review_question_id: zod.number().optional(),
                    review_config_id: zod.number().optional(),
                    question_text_th: zod
                        .string()
                        .max(getReviewQuestions200ResponseDataItemQuestionTextThMax)
                        .optional(),
                    question_text_en: zod
                        .string()
                        .max(getReviewQuestions200ResponseDataItemQuestionTextEnMax)
                        .optional(),
                    question_text_ja: zod
                        .string()
                        .max(getReviewQuestions200ResponseDataItemQuestionTextJaMax)
                        .optional(),
                    data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
                    options: zod.array(zod.string()).optional(),
                    option_th: zod.array(zod.string()).optional(),
                    option_en: zod.array(zod.string()).optional(),
                    option_ja: zod.array(zod.string()).optional(),
                    is_required: zod.number().optional(),
                    is_active: zod.number().optional(),
                    created_at: zod.string().datetime({ offset: true }).optional(),
                    updated_at: zod.string().datetime({ offset: true }).optional(),
                })
                .strict(),
        ),
    })
    .strict();

export const GetReviewQuestions404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewQuestions500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create new review question
 */

export const CreateReviewQuestionParams = zod
    .object({
        review_config_id: zod.number().min(1),
    })
    .strict();

export const CreateReviewQuestionHeader = zod
    .object({
        "Content-Type": zod.enum(["application/json"]).describe("Content type of the request body"),
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const createReviewQuestionBodyQuestionTextThMax = 200;

export const createReviewQuestionBodyQuestionTextEnMax = 200;

export const createReviewQuestionBodyQuestionTextJaMax = 200;

export const createReviewQuestionBodyIsRequiredDefault = 1;
export const createReviewQuestionBodyIsActiveDefault = 1;

export const CreateReviewQuestionBody = zod
    .object({
        question_text_th: zod.string().max(createReviewQuestionBodyQuestionTextThMax),
        question_text_en: zod.string().max(createReviewQuestionBodyQuestionTextEnMax),
        question_text_ja: zod.string().max(createReviewQuestionBodyQuestionTextJaMax),
        data_type: zod.enum(["rating", "text", "single_select", "multi_select"]),
        options: zod.array(zod.string()).optional(),
        option_th: zod.array(zod.string()).optional(),
        option_en: zod.array(zod.string()).optional(),
        option_ja: zod.array(zod.string()).optional(),
        is_required: zod.number().default(createReviewQuestionBodyIsRequiredDefault),
        is_active: zod.number().default(createReviewQuestionBodyIsActiveDefault),
    })
    .strict();

export const createReviewQuestion201ResponseDataItemQuestionTextThMax = 200;

export const createReviewQuestion201ResponseDataItemQuestionTextEnMax = 200;

export const createReviewQuestion201ResponseDataItemQuestionTextJaMax = 200;

export const CreateReviewQuestion201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_question_id: zod.number().optional(),
                        review_config_id: zod.number().optional(),
                        question_text_th: zod
                            .string()
                            .max(createReviewQuestion201ResponseDataItemQuestionTextThMax)
                            .optional(),
                        question_text_en: zod
                            .string()
                            .max(createReviewQuestion201ResponseDataItemQuestionTextEnMax)
                            .optional(),
                        question_text_ja: zod
                            .string()
                            .max(createReviewQuestion201ResponseDataItemQuestionTextJaMax)
                            .optional(),
                        data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
                        options: zod.array(zod.string()).optional(),
                        option_th: zod.array(zod.string()).optional(),
                        option_en: zod.array(zod.string()).optional(),
                        option_ja: zod.array(zod.string()).optional(),
                        is_required: zod.number().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateReviewQuestion400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const CreateReviewQuestion404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const CreateReviewQuestion500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get specific review question
 */

export const GetReviewQuestionParams = zod
    .object({
        review_config_id: zod.number().min(1),
        review_question_id: zod.number().min(1),
    })
    .strict();

export const GetReviewQuestionHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const getReviewQuestion200ResponseDataItemQuestionTextThMax = 200;

export const getReviewQuestion200ResponseDataItemQuestionTextEnMax = 200;

export const getReviewQuestion200ResponseDataItemQuestionTextJaMax = 200;

export const GetReviewQuestion200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_question_id: zod.number().optional(),
                        review_config_id: zod.number().optional(),
                        question_text_th: zod
                            .string()
                            .max(getReviewQuestion200ResponseDataItemQuestionTextThMax)
                            .optional(),
                        question_text_en: zod
                            .string()
                            .max(getReviewQuestion200ResponseDataItemQuestionTextEnMax)
                            .optional(),
                        question_text_ja: zod
                            .string()
                            .max(getReviewQuestion200ResponseDataItemQuestionTextJaMax)
                            .optional(),
                        data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
                        options: zod.array(zod.string()).optional(),
                        option_th: zod.array(zod.string()).optional(),
                        option_en: zod.array(zod.string()).optional(),
                        option_ja: zod.array(zod.string()).optional(),
                        is_required: zod.number().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetReviewQuestion404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewQuestion500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Update review question
 */

export const UpdateReviewQuestionParams = zod
    .object({
        review_config_id: zod.number().min(1),
        review_question_id: zod.number().min(1),
    })
    .strict();

export const UpdateReviewQuestionHeader = zod
    .object({
        "Content-Type": zod.enum(["application/json"]).describe("Content type of the request body"),
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const updateReviewQuestionBodyQuestionTextMax = 500;

export const updateReviewQuestionBodyQuestionTextThMax = 200;

export const updateReviewQuestionBodyQuestionTextEnMax = 200;

export const updateReviewQuestionBodyQuestionTextJaMax = 200;

export const UpdateReviewQuestionBody = zod
    .object({
        question_text: zod.string().max(updateReviewQuestionBodyQuestionTextMax).optional(),
        question_text_th: zod.string().max(updateReviewQuestionBodyQuestionTextThMax).optional(),
        question_text_en: zod.string().max(updateReviewQuestionBodyQuestionTextEnMax).optional(),
        question_text_ja: zod.string().max(updateReviewQuestionBodyQuestionTextJaMax).optional(),
        data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
        options: zod.array(zod.string()).optional(),
        option_th: zod.array(zod.string()).optional(),
        option_en: zod.array(zod.string()).optional(),
        option_ja: zod.array(zod.string()).optional(),
        is_required: zod.number().optional(),
        is_active: zod.number().optional(),
        sort_order: zod.number().optional(),
    })
    .strict();

export const updateReviewQuestion200ResponseDataItemQuestionTextThMax = 200;

export const updateReviewQuestion200ResponseDataItemQuestionTextEnMax = 200;

export const updateReviewQuestion200ResponseDataItemQuestionTextJaMax = 200;

export const UpdateReviewQuestion200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        review_question_id: zod.number().optional(),
                        review_config_id: zod.number().optional(),
                        question_text_th: zod
                            .string()
                            .max(updateReviewQuestion200ResponseDataItemQuestionTextThMax)
                            .optional(),
                        question_text_en: zod
                            .string()
                            .max(updateReviewQuestion200ResponseDataItemQuestionTextEnMax)
                            .optional(),
                        question_text_ja: zod
                            .string()
                            .max(updateReviewQuestion200ResponseDataItemQuestionTextJaMax)
                            .optional(),
                        data_type: zod.enum(["rating", "text", "single_select", "multi_select"]).optional(),
                        options: zod.array(zod.string()).optional(),
                        option_th: zod.array(zod.string()).optional(),
                        option_en: zod.array(zod.string()).optional(),
                        option_ja: zod.array(zod.string()).optional(),
                        is_required: zod.number().optional(),
                        is_active: zod.number().optional(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdateReviewQuestion400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateReviewQuestion404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateReviewQuestion500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Delete review question
 */

export const DeleteReviewQuestionParams = zod
    .object({
        review_config_id: zod.number().min(1),
        review_question_id: zod.number().min(1),
    })
    .strict();

export const DeleteReviewQuestionHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const DeleteReviewQuestion404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const DeleteReviewQuestion500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get review answer for a post
 */

export const GetReviewAnswerParams = zod
    .object({
        board_id: zod.enum([
            "review",
            "tiktoks",
            "beauty_news",
            "editorial_reviews",
            "expert_reviews",
            "activities",
            "test_modal",
            "test_modeless",
            "guidance",
        ]),
        post_id: zod.number().min(1),
    })
    .strict();

export const GetReviewAnswerHeader = zod
    .object({
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const GetReviewAnswer200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .union([
                        zod
                            .object({
                                review_answer_id: zod.number().optional(),
                                review_config_id: zod.number().optional(),
                                post_id: zod.number().optional(),
                                product_id: zod.number().optional(),
                                answers: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                answer_value: zod.string().optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict(),
                        zod.null(),
                    ])
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetReviewAnswer404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetReviewAnswer500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Submit review answer for a post
 */

export const CreateReviewAnswerParams = zod
    .object({
        board_id: zod.enum([
            "review",
            "tiktoks",
            "beauty_news",
            "editorial_reviews",
            "expert_reviews",
            "activities",
            "test_modal",
            "test_modeless",
            "guidance",
        ]),
        post_id: zod.number().min(1),
    })
    .strict();

export const CreateReviewAnswerHeader = zod
    .object({
        "Content-Type": zod.enum(["application/json"]).describe("Content type of the request body"),
        Accept: zod.enum(["application/json"]).describe("Content type that client accepts"),
    })
    .strict();

export const CreateReviewAnswerBody = zod
    .object({
        product_id: zod.number(),
        answers: zod.array(
            zod
                .object({
                    review_question_id: zod.number(),
                    answer_value: zod.string(),
                })
                .strict(),
        ),
    })
    .strict();

export const CreateReviewAnswer201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .union([
                        zod
                            .object({
                                review_answer_id: zod.number().optional(),
                                review_config_id: zod.number().optional(),
                                post_id: zod.number().optional(),
                                product_id: zod.number().optional(),
                                answers: zod
                                    .array(
                                        zod
                                            .object({
                                                review_question_id: zod.number().optional(),
                                                answer_value: zod.string().optional(),
                                            })
                                            .strict(),
                                    )
                                    .optional(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict(),
                        zod.null(),
                    ])
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateReviewAnswer400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const CreateReviewAnswer404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();

export const CreateReviewAnswer500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod
            .union([zod.literal(400), zod.literal(404), zod.literal(422), zod.literal(500)])
            .describe("HTTP status code"),
    })
    .strict();
